import { useEffect, useState } from "react"
import * as PropTypes from "prop-types"
import isEqual from "lodash/isEqual"
import castArray from "lodash/castArray"
import includes from "lodash/includes"
import xor from "lodash/xor"
import styled from "styled-components"
import { Row } from "components/styled/Grid"
import Typography from "components/styled/Typography"
import join from "lodash/join"
import useDidUpdate from "hooks/useDidUpdate"
import Item from "./Item"

const Container = styled(Row)`
  margin-right: -8px;
  margin-left: -8px;
`

const Feedback = styled(Typography)`
  && {
    font-size: 1rem;
    width: 100%;
    margin: 0.25rem 0 0;
  }
`

export default function Selector({ field, initialValue, options, handleChange, multiple, col, errors }) {
  const val = initialValue || (multiple ? [] : null)
  const [value, setValue] = useState(val)

  useEffect(() => {
    if (!isEqual(initialValue, value)) setValue(initialValue)
  }, [initialValue])

  useDidUpdate(() => {
    if (!isEqual(initialValue, value)) {
      handleChange(field, value)
    }
  }, [value])

  const errorsValue = errors && errors[field]

  const errorsText = Array.isArray(errorsValue) ? join(errorsValue) : errorsValue

  const onChange = x => (multiple ? setValue(xor(value, castArray(x))) : setValue(x === value ? null : x))

  const checkSelection = item => (multiple ? includes(value, item) : value === item)

  // if (dynamic && options.length <= 1) return null

  return (
    <>
      <Container>
        {options.map(opt => (
          <Item
            key={opt.value}
            {...opt}
            onChange={onChange}
            selected={checkSelection(opt.value)}
            col={col}
            disabled={opt.disabled}
          />
        ))}
      </Container>
      {errorsText && (
        <Feedback color="crimson" weight="medium" style={{ textAlign: "left" }}>
          {errorsText}
        </Feedback>
      )}
    </>
  )
}

Selector.defaultProps = {
  multiple: false,
  initialValue: null,
  col: { xs: 6, lg: 12 },
  errors: {},
  dynamic: false
}

Selector.propTypes = {
  initialValue: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
  options: PropTypes.array.isRequired,
  multiple: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  field: PropTypes.string.isRequired,
  col: PropTypes.object,
  errors: PropTypes.object,
  dynamic: PropTypes.bool
}
